import { FormControl, FormGroup, Validators } from "@angular/forms";
import { IStockTypeFormControls } from "../interfaces/stock-type-form-controls.interface";
import { IStockTypeDTO } from "../interfaces/stock-type.interface";
import { TControlsValue } from "../../../../../kernel/form/types/form-controls-utils.types";
import { Injectable } from "@angular/core";
import { EntityFormModel } from "../../../../../kernel/form/classes/entity-form-model";
import { IStockType } from "@app/shared/settings/stock-type/interfaces/stock-type.interface";

@Injectable()
export class StockTypeForm extends EntityFormModel<IStockType, IStockTypeDTO, IStockTypeFormControls> {
  /**
   * Handles form initialization with a given entity.
   * If an entity is provided, it sets the entity to the form.
   * Optionally disables the form if viewMode is true.
   *
   * @param entity - The stock type entity to initialize the form with.
   * @param viewMode - Whether the form should be in a disabled (view-only) state.
   */
  handleFormWithEntity(entity: IStockType | null, viewMode: boolean) {
    if (entity) {
      this.setEntity(entity);
      if (viewMode) {
        this.formGroup().disable({ emitEvent: false });
      }
    }
  }

  protected override createFormGroup(initialValue: TControlsValue<IStockTypeFormControls>): FormGroup<IStockTypeFormControls> {
    return new FormGroup<IStockTypeFormControls>({
      name: new FormControl(initialValue?.name, { nonNullable: true, validators: [Validators.required] }),
      code: new FormControl(initialValue?.code, {
        nonNullable: true,
        validators: [Validators.required],
        asyncValidators: this.buildAsyncValidator(() => ({
          isUnique: {
            query: "stockTypes",
            match: "code",
            self: this.entity()?.id,
          },
        })),
      }),
      description: new FormControl(initialValue?.description, { nonNullable: true }),
      image: new FormControl(initialValue?.image, { nonNullable: true, validators: [Validators.required] }),
      enabled: new FormControl(initialValue?.enabled, { nonNullable: true, validators: [Validators.required] }),
    });
  }

  formValueToDtoInput(formValue: TControlsValue<IStockTypeFormControls>): IStockTypeDTO {
    return {
      ...formValue,
      enabled: !this.entity() ? formValue.enabled : undefined,
    };
  }

  entityToFormValue(entity?: Partial<IStockType> | null): TControlsValue<IStockTypeFormControls> {
    return {
      name: entity?.name ?? "",
      code: entity?.code ?? "",
      description: entity?.description ?? "",
      image: entity?.image ?? "",
      enabled: entity?.enabled ?? true,
    };
  }
}
